import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/placeholder.css';
import './styles/hr-mobile.css';
import './styles/workspace.css';   // 새 디자인 언어 — Tailwind 뒤에 와야 덮어쓴다
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import SmsReauthGate from './components/auth/SmsReauthGate';
import { ToastProvider } from './context/ToastContext';
import { SystemModeProvider } from './context/SystemModeContext';

// 개발 환경에서만 MSW 가져오기
async function enableMocking() {
  // MSW 비활성화 - 실제 API 호출이 서버로 전달되도록 합니다
  return;

  /* 기존 MSW 초기화 코드 (주석 처리)
  if (process.env.NODE_ENV !== 'development') {
    console.log('프로덕션 환경에서는 MSW를 사용하지 않습니다.');
    return;
  }

  try {
    console.log('MSW 초기화 시작...');
    
    if (typeof window === 'undefined') {
      console.log('브라우저 환경이 아닙니다.');
      return;
    }
    
    const { worker } = await import('./mocks/browser');
    
    // MSW 디버깅 옵션 설정
    const options = {
      onUnhandledRequest: 'warn', // 처리되지 않은 요청에 대한 경고 표시
      serviceWorker: {
        url: `${process.env.PUBLIC_URL}/mockServiceWorker.js`,
      },
    };
    
    console.log('MSW 시작 옵션:', options);
    
    // MSW 시작
    await worker.start(options);
    console.log('MSW 초기화 완료 - 모의 API 서버가 실행 중입니다');
    
    // MSW가 활성화됨을 알리는 콘솔 로그
    console.log('%cMock Service Worker가 활성화되었습니다!', 'color: #ff0000; font-weight: bold;');
  } catch (error) {
    console.error('MSW 초기화 실패:', error);
  }
  */
}

// MSW 초기화 후 앱 렌더링
enableMocking().then(() => {
  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
  root.render(
    <BrowserRouter future={{ v7_startTransition: true }}>
      <ThemeProvider>
        <ToastProvider>
          <AuthProvider>
            <SystemModeProvider>
              <Suspense fallback={<div>로딩 중...</div>}>
                <App />
              </Suspense>
              {/*
                ⛔ 라우터 «안»이 아니라 여기에 둔다. 어느 화면에서 재인증이 필요해져도
                   떠야 하고, 화면이 바뀌어도 살아 있어야 한다.
                   `AuthProvider` 안이어야 `logout()` 을 쓸 수 있다.
              */}
              <SmsReauthGate />
            </SystemModeProvider>
          </AuthProvider>
        </ToastProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
